import { useEffect, useState } from "react"

import { Modal, Space, Typography } from "antd"
import cls from "classnames"
import { useSelector } from "react-redux"

import ConnectPaymentProcessorForm from "../../../Components/Forms/ConnectPaymentProcessorForm"
import Icon from "../../../Icon"
import AppUtils from "../../../Utils/utils"
import { getNextcommerceUrl } from "../../User/services"

const { Text } = Typography

const fieldRules = {
  store: [
    {
      validator: (_, value) => {
        if (value && !/^[A-Za-z0-9-]+$/.test(value)) {
          return Promise.reject(
            new Error("Store name can only contain letters, numbers, and hyphen.")
          )
        }
        return Promise.resolve()
      }
    }
  ]
}

const ConnectNextcommerce = ({ onFinish, isMobile }) => {
  const [showModal, setShowModal] = useState(false)
  const fields = useSelector((state) =>
    state.user.paymentProcessors
      ?.find((p) => p.service_name === "next")
      ?.list_of_required_fields_for_tokens?.filter((field) => field?.id !== "api_key")
      ?.map((field) => ({ ...field, rules: fieldRules[field.id] }))
  )

  useEffect(() => {
    setShowModal(true)
  }, [])

  const closeModal = () => {
    setShowModal(false)
    onFinish()
  }

  const getUrlForStore = async (store) => {
    const response = await getNextcommerceUrl(store)
    if (!response.ok) return null
    return typeof response.data === "string" ? response.data : null
  }

  const onSubmit = (data) => {
    const store = data.store?.trim()?.toLowerCase()
    getUrlForStore(store).then((url) => {
      if (url) {
        AppUtils.goLink(url)
      } else {
        onFinish()
      }
    })
  }

  return (
    <Modal
      open={showModal}
      centered={!isMobile}
      width={442}
      title={
        <Space direction="vertical">
          <Text className="payment-connect-title">Next Commerce integration</Text>
          <Text className="payment-connect-sub_title">
            Connect your Next Commerce account to automate refunds for incoming alerts
          </Text>
        </Space>
      }
      footer={null}
      closeIcon={<Icon type="cross_small" style={{ color: "#7A7A83" }} />}
      closable="true"
      onCancel={closeModal}
      destroyOnClose
      classNames={{
        content: cls("clear-bg full-width-header", "payment-connect"),
        header: cls("payment-connect", "next")
      }}
    >
      <ConnectPaymentProcessorForm
        fields={fields}
        service_name="next"
        onSubmit={onSubmit}
        onClose={closeModal}
        isMobile={isMobile}
      />
    </Modal>
  )
}

export default ConnectNextcommerce
